<ng-template #templateRef>
    <mat-dialog-content>
        <h2 mat-dialog-title>Pick your promotions
            <span class="text-right">
            <button mat-icon-button (click)="showFilters = !showFilters" type="button" id="showFilter">
                <mat-icon>filter_list</mat-icon>
            </button>
            </span>
        </h2>
        <mat-card appearance="outlined" style="margin-bottom: 50px;" [hidden]="!showFilters">
            <form #filterForm="ngForm" name="filterForm" (ngSubmit)="filter(filterForm.value)">
                <mat-card-title class="filter-title">Filter</mat-card-title>
                <mat-card-content>
                    <div class="row">
                        <div class="col-md-3">
                            <mat-form-field>
                              <mat-label>Title</mat-label>
                                <input matInput name="Title" ngModel>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field>
                              <mat-label>Delivery from</mat-label>
                                <input matInput name="DeliveryFrom" ngModel [multiple]="true" ngModel
                                       [matDatepicker]="actionpicker5">
                                <mat-datepicker-toggle matIconSuffix [for]="actionpicker5"></mat-datepicker-toggle>
                                <mat-datepicker #actionpicker5></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field>
                              <mat-label>Delivery until</mat-label>
                                <input matInput name="DeliveryUntil" ngModel [multiple]="true" ngModel
                                       [matDatepicker]="actionpicker6">
                                <mat-datepicker-toggle matIconSuffix [for]="actionpicker6"></mat-datepicker-toggle>
                                <mat-datepicker #actionpicker6></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <mat-form-field>
                              <mat-label>Start date from</mat-label>
                                <input matInput name="StartFrom" ngModel [multiple]="true" ngModel
                                       [matDatepicker]="actionpicker1">
                                <mat-datepicker-toggle matIconSuffix [for]="actionpicker1"></mat-datepicker-toggle>
                                <mat-datepicker #actionpicker1></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field>
                              <mat-label>Start date until</mat-label>
                                <input matInput name="StartUntil" ngModel [multiple]="true" ngModel
                                       [matDatepicker]="actionpicker2">
                                <mat-datepicker-toggle matIconSuffix [for]="actionpicker2"></mat-datepicker-toggle>
                                <mat-datepicker #actionpicker2></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field>
                              <mat-label>End date from</mat-label>
                                <input matInput name="EndFrom" ngModel [multiple]="true" ngModel
                                       [matDatepicker]="actionpicker3">
                                <mat-datepicker-toggle matIconSuffix [for]="actionpicker3"></mat-datepicker-toggle>
                                <mat-datepicker #actionpicker3></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field>
                              <mat-label>End date until</mat-label>
                                <input matInput name="EndUntil" ngModel [multiple]="true" ngModel
                                       [matDatepicker]="actionpicker4">
                                <mat-datepicker-toggle matIconSuffix [for]="actionpicker4"></mat-datepicker-toggle>
                                <mat-datepicker #actionpicker4></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                </mat-card-content>
              <mat-card-actions>
                <div style="margin: auto">
                  <button mat-button>Filter results</button>
                  <button mat-button (click)="showFilters = false">Close</button>
                </div>
              </mat-card-actions>
            </form>
        </mat-card>
        <form #editorForm="ngForm" name="editRelation" id="articleEditor" (ngSubmit)="save()">
            <mat-tab-group>
                <mat-tab label="Graphic">
                    <div class="row">
                        <table class="mat-mdc-table">
                            <tr>
                                <td>
                                    <mat-checkbox (change)="onToggleAll($event)"></mat-checkbox>
                                </td>
                                <td>Title</td>
                                <td>Start</td>
                                <td>End</td>
                            </tr>
                            <tr *ngFor="let promotion of Promotions">
                                <td>
                                    <mat-checkbox [checked]="isSelected(promotion)" (change)="onToggle($event, promotion)"></mat-checkbox>
                                </td>
                                <td>
                                    {{promotion.getTitle()}}
                                </td>
                                <td>
                                    {{promotion.StartDate | date: 'shortDate'}}
                                </td>
                                <td>
                                    {{promotion.EndDate | date: 'shortDate'}}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <mat-paginator [length]="filterObject.count" [pageSize]="filterObject.limit"
                                           [pageSizeOptions]="[5, 10, 25, 100]" (page)="pageChange($event);"></mat-paginator>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Selected ({{Selected.length}})">
                    <table class="mat-mdc-table">
                        <tr>
                            <td>Name</td>
                            <td>Code</td>
                        </tr>
                        <tr *ngFor="let promotion of Selected">
                            <td>
                                {{promotion.getTitle()}}
                            </td>
                            <td>
                                {{promotion.StartDate | date: 'shortDate'}}
                            </td>
                            <td>
                                {{promotion.EndDate | date: 'shortDate'}}
                            </td>
                        </tr>
                    </table>
                </mat-tab>
            </mat-tab-group>
            <mat-dialog-actions>
                <div class="fill-remaining-space"></div>
                <button type="button" mat-button mat-raised-button mat-dialog-close>Close</button>
                <app-button [disabled]="!editorForm.form.valid" [isLoading]="isLoading"></app-button>
            </mat-dialog-actions>
        </form>
    </mat-dialog-content>

</ng-template>
